import { useQuery } from '@tanstack/react-query';
import { countriesApi } from '../api/countries.api';
import type { CountryDetail } from '../types/countries.types';
import { countryKeys } from './queryKeys';

export const useCountryById = (id: string) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: countryKeys.detail(id),
    queryFn: () => countriesApi.getCountryById(id),
    enabled: !!id,
    retry: false,
  });

  return {
    country: data?.data as CountryDetail | undefined,
    isLoading,
    refetch,
  };
};
